<template>
  <div id="app" :class="layout">
      <router-view></router-view>
  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import axios from "axios";
import gql from "@/graphql/apollo"

window.commonData = {
  isPublice: false,
};
export default {
  /*
  * 关闭浏览器登出
  * */
  // mounted() {
  //   var client_id = window.commonApi.SSO_KEY;
  //   var authority = window.commonApi.SSO_URL + "/oauth2";
  //   var user = JSON.parse(localStorage.getItem("oidc.user:"+authority+":"+client_id));
  //   if (document.cookie.indexOf("loginInfo=true")==-1) {
  //     document.cookie ='loginInfo=true';
  //     if (user.access_token){
  //       this.$store.dispatch("oidcStore/signOutOidc");
  //     }
  //   }
  // },
  data(){
    return{
      _beforeUnload_time:null,
      _gap_time:null,
    }
  },
  methods:{
    beforeunloadHandler(){
      this._beforeUnload_time=new Date().getTime()
    },
    unloadHandler(e){
      console.log(e,'eeeeeeeeee')
      this._gap_time=new Date().getTime()-this._beforeUnload_time
      debugger
      //判断是窗口关闭还是刷新
      if(this._gap_time<=5){
        //如果是登录状态，关闭窗口前，退出登录
        this.$store.dispatch('oidcStore/signOutOidc');
      }else {

      }
    },
  },
  mounted() {
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.addEventListener('unload', e => this.unloadHandler(e))
  },
  destroyed() {
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    window.removeEventListener('unload', e => this.unloadHandler(e))
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcUser"]),
    getIdToken() {
      return this.$store.state.oidcStore.id_token;
    },
    getMobile() {
      var flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag === null) {
        return false;
      } else {
        return true;
      }
    },
    layout() {
      let meta = this.getMobile;
      let layout = meta ? "mobile" : "pc";
      return layout;
    },
  },
  watch: {
    // '$route': {
    //   immediate: true,
    //   handler(oldV) {
    //     if (oldV.path == '/workflow/oidcCallback') {
    //       setTimeout(() => {
    //         axios.get(`${location.origin}${window.commonApi.PATH}/api/accessRecord?labelName=loginOnce`).then(res => {
    //         }).catch(error => {
    //           console.log(error);
    //         });
    //       }, 1500)
    //     }
    //
    //     // 判断是否第一次登陆（只有第一次出现未登陆页面），
    //     // 获取IS-ONCE-LOGIN 如果没有存一份，如果有就跳index
    //     if (oldV.path == '/workflow/home') {
    //       if (sessionStorage.getItem('IS-ONCE-LOGIN')) {
    //         this.$router.push('/workflow/index');
    //       } else {
    //         sessionStorage.setItem('IS-ONCE-LOGIN', true);
    //       }
    //     }
    //
    //     // 记录移动端登录次数
    //     if (this.getMobile) {
    //       setTimeout(() => {
    //         axios.get(`${location.origin}${window.commonApi.PATH}/api/accessRecord?labelName=RECORD_WECHAT_LOGIN`).then(res => {
    //         }).catch(error => {
    //           console.log(error);
    //         });
    //       }, 1500)
    //     }
    //   }
    // },
    getIdToken: {
      deep: true,
      immediate: true,
      handler(oldV) {
        if (oldV) {
          apolloProvider.clients.builtin.query({
            client: 'builtin',
            fetchPolicy: "network-only",
            query: gql.getPosts,
            variables: {
              first: 1,
              offset: 0
            }
          }).catch(error => {
            try {
              if (JSON.stringify(error).indexOf('OIDC_BC_LOGOUT') !== -1) {
                // this.signOutOidc();
                this.$store.dispatch('oidcStore/signOutOidc');
              }
            } catch (e) {
              console.log(e);
            }
          })
        }
      }
    }
  },
};
</script>
<style>
@import "~@/assets/todoCenter/default/css/other.css";
</style>
<style lang='less'>
@import "~@/assets/todoCenter/default/css/main.less";
</style>



// WEBPACK FOOTER //
// src/App.vue